<template>
  <div
    v-if="bindProduct"
    class="grid-container p-card"
    :class="{
      invalid: bindProduct.isValid() === false,
    }"
  >
    <div class="p-card-item p-card__name">
      <div style="width: 80%">
        <template v-if="initializedToAddition || isEditable">
          <v-text-field
            v-model="bindProduct.title"
            dense
            flat
            hide-details
            outlined
            placeholder="상품명"
            class="mb-2"
          ></v-text-field>
          <v-text-field
            v-model="bindProduct.option"
            dense
            flat
            hide-details
            outlined
            placeholder="상품 옵션"
          ></v-text-field>
        </template>
        <template v-else>
          <p class="font--m-3 mb-1">
            {{ bindProduct.title }}
          </p>
          <p class="mb-0">[{{ bindProduct.option || '옵션 없음' }}]</p>
        </template>
      </div>
      <div>
        <v-icon size="28" class="cursor--pointer" :disabled="isDisabled" @click="remove()">
          mdi-delete
        </v-icon>
      </div>
    </div>
    <div class="p-card-item p-card__img" :class="{ default: isDefaultImage }">
      <template v-if="isDefaultImage">
        <DefaultImage />
      </template>
      <template v-else>
        <picture>
          <img :src="realThumbnailUrl" />
        </picture>
      </template>
    </div>
    <div class="p-card-item p-card__whosaler">
      <v-text-field
        dense
        flat
        hide-details
        single-line
        solo
        outlined
        placeholder="거래처"
        readonly
        :value="bindProduct.wholesaler.name"
        :disabled="isDisabled"
        @click="openWhosalerFinder()"
      ></v-text-field>
    </div>
    <div class="p-card-item p-card__amount">
      <v-text-field
        dense
        flat
        hide-details
        outlined
        label="단가"
        placeholder="상품 단가"
        :value="showUnitCost"
        @input="inputUnitCost"
        @focus="focusUnitCost"
        @blur="blurUnitCost"
        suffix=" 원"
      ></v-text-field>
    </div>
    <div class="p-card-item p-card__ea">
      <div class="d-flex align-center">
        <v-btn icon tile width="20px" :disabled="isDisabled" @click="decrease()">
          <v-icon size="20" color="#222222">mdi-minus</v-icon>
        </v-btn>
        <input
          v-input-comma="bindProduct.quantity"
          autocomplete
          min="1"
          :value="bindProduct.quantity"
        />
        <v-btn icon tile width="20px" :disabled="isDisabled" @click="increase()">
          <v-icon size="20" color="#222222">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DefaultImage from '@/components/common/image/DefaultImage.vue'

export default {
  props: {
    product: {
      type: Object,
      default() {
        return {}
      },
    },
    listId: {
      type: String,
      default: null,
    },
    isAddition: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DefaultImage,
  },
  data() {
    return {
      isLoading: false,
      bindProduct: null,
      showUnitCost: 0,
    }
  },
  computed: {
    ...mapGetters('product', ['getRequiredFields']),
    initializedToAddition() {
      const prefixIsAddition = this.product.uuid.startsWith('ADDITION_')
      return this.isAddition === true && prefixIsAddition === true
    },
    isEditable() {
      return this.bindProduct?.mall.uuid === 'ADDITION'
    },
    isDisabled() {
      return this.isLoading === true
    },
    isSavable() {
      let isNotNull = false
      let isNotNullSub = false
      let gtZero = false
      for (const field of this.getRequiredFields) {
        const key = field.name

        if (field.isNumber === true) {
          gtZero = this.bindProduct[key] > 0
        } else {
          isNotNull = !!this.bindProduct[key]
        }

        if (field.subField) {
          isNotNullSub = !!this.bindProduct[field.subField]
        }
      }
      return (isNotNull === true || isNotNullSub === true) && gtZero === true
    },
    realThumbnailUrl() {
      const url = this.bindProduct?.thumbnailUrl || 'icons/no-image.svg'
      if (url.startsWith('http') === true) {
        return url
      } else {
        return require(`@/assets/images/${url}`)
      }
    },
    isDefaultImage() {
      return !!this.bindProduct.thumbnailUrl === false
    },
    totalCost() {
      const cost = this.bindProduct?.purchaseUnitCost ?? 0
      const quantity = this.bindProduct?.quantity ?? 0
      return this.$options.filters.commaFormat(cost * quantity)
    },
    exportData() {
      return {
        ...this.bindProduct,
        totalCost: this.totalCost,
      }
    },
  },
  watch: {
    bindProduct: {
      deep: true,
      async handler(nv, ov) {
        if (ov === null) {
          if (this.initializedToAddition) {
            this.add()
          }

          return
        }

        if (this.isSavable === false) {
          return
        }

        await this.modify()
        this.$emit('emitProduct', nv)
      },
    },
  },
  created() {
    this.bindP()
  },
  methods: {
    ...mapActions('product', ['addProductItem', 'modifyProductItem', 'removeProductItem']),
    convertToParam() {
      const param = { ...this.bindProduct }
      if (this.initializedToAddition) {
        param.title = '상품명을 입력해주세요'
        delete param.uuid
        delete param.mall
      } else {
        if (param.mall.uuid === 'ADDITION') {
          delete param.mall
        }
      }

      if (param?.wholesaler.uuid === null) {
        delete param.wholesaler
      }
      return param
    },
    openWhosalerFinder() {
      this.$emit('emitOpenWhosalerFinder', this.bindProduct)
    },
    bindP() {
      // const temp = { ...this.product }
      this.bindProduct = this.product
      this.showUnitCost = this.$options.filters.commaFormat(this.product.purchaseUnitCost)
    },
    inputUnitCost(e) {
      let temp = this.$options.filters.commaRemove(e)
      temp = parseInt(temp, 10)
      this.bindProduct.purchaseUnitCost = temp
      this.showUnitCost = this.$options.filters.commaFormat(temp)
    },
    focusUnitCost() {
      if (this.showUnitCost == 0) {
        this.showUnitCost = null
      }
    },
    blurUnitCost() {
      if (this.showUnitCost === null) {
        this.showUnitCost = 0
      }
    },
    decrease() {
      if (this.isDisabled) {
        return
      }
      const intVal = parseInt(this.$options.filters.commaRemove(this.bindProduct.quantity), 10)
      const temp = intVal - 1
      this.bindProduct.quantity = temp < 1 ? 1 : temp
    },
    increase() {
      if (this.isDisabled) {
        return
      }
      const intVal = parseInt(this.$options.filters.commaRemove(this.bindProduct.quantity), 10)
      this.bindProduct.quantity = intVal + 1
    },
    async add() {
      if (this.isDisabled) {
        return
      }
      this.isLoading = true

      const param = this.convertToParam()
      const result = await this.addProductItem({ listUUID: this.listId, product: param })
      if (this.initializedToAddition) {
        this.bindProduct.uuid = result.uuid
      }

      this.isLoading = false
    },
    async modify() {
      if (this.isDisabled) {
        return
      }
      this.isLoading = true

      const param = this.convertToParam()
      await this.modifyProductItem(param)

      this.isLoading = false
    },
    async remove() {
      if (this.isDisabled) {
        return
      }

      const confirm = await this.$swal.basic.confirm('선택하신 상품을 정말 제거하시겠습니까?')

      if (confirm.isConfirmed !== true) {
        return
      }

      this.isLoading = true

      try {
        if (this.initializedToAddition === false) {
          await this.removeProductItem(this.bindProduct.uuid)
        }
        this.$emit('emitRemoveProduct', this.bindProduct)
      } catch (e) {
        this.$swal.basic.error('현재 상품을 제거할 수 없습니다. 잠시 후 다시 시도해주세요.')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.unit-cost {
  border: 1px solid $gray-80;
  border-radius: $border-radius-default;
  padding: 5px;
}

.grid-container {
  display: grid;

  column-gap: 5px;

  grid-auto-rows: auto;
  grid-template-columns: 90px minmax(90px, 1.2fr) minmax(90px, 1fr);

  grid-template-areas:
    'name name name'
    'img whosaler whosaler'
    'img amount ea';
}

.p-card.p-card--disabled::v-deep .v-input__slot {
  background-color: transparent;
}

.p-card {
  background-color: $white;
  box-shadow: 3px 5px 12px rgb(189, 189, 189, 0.8);
  padding: 5px;

  &.p-card--disabled {
    background-color: rgb(174, 174, 174, 0.2) !important;
  }

  &.invalid {
    border: 2px solid $pinkred-110;
  }

  &__name {
    grid-area: name;

    display: flex;
    justify-content: space-between;
  }

  &__img {
    grid-area: img;
    height: 100px;

    img {
      width: 90px;
      height: 100px;
      object-fit: contain;
    }

    &.default {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  &__whosaler {
    grid-area: whosaler;

    display: flex;
    align-items: center;
  }

  &__amount {
    grid-area: amount;

    display: flex;
    align-items: center;

    &::v-deep input {
      font-size: 14px;
    }
  }

  &__ea {
    grid-area: ea;

    input {
      font-size: 14px;
      font-weight: bold;
    }

    > div {
      height: 100%;
    }

    button {
      width: 28px !important;
      flex-grow: 0;

      border: 1px solid $gray-80;
      border-radius: $border-radius-default;
    }

    input {
      width: 0;
      flex-grow: 2.5;
      text-align: center;
    }
  }
}
</style>
